import WithContextProvider from './withContextProvider.view';

export default WithContextProvider;
